import moment from "moment"

export function sortCols(columns: Array<any>, colIndex: string | number) {
    try {
        return columns.map((r, index) => {
            let order = null
            let loading = false
            if (colIndex == index) {
                loading = true
                order = r.order == null ? 'ASC' : r.order == 'ASC' ? 'DESC' : null
            }
            const l = {
                ...r,
                order,
                loading

            }
            return l
        })
    } catch (e) {
        console.log(e)
        return columns
    }

}
export function dataURLtoFile(dataurl: string, filename: string): File {

    var arr = dataurl.split(',')
    var type
    var mime: any = arr[0].match(/:(.*?);/)
    type = mime[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type });

}

export function replacePhoneNumberToHash(text: string) {
    let res = "";

    if (text) {
        for (let i = 0; i < text.length; i++) {
            if (text[i] === "9") {
                res += "#";
            } else {
                res += text[i];
            }
        }
    }

    return res;
};

export function toPattern(value: string, mode = "cpf", customPattern = "") {
    let newString = "";
    let stringIndex = 0;
    try {
        let pattern = Array(value.length).fill("#").join();

        switch (mode) {
            case "cpf":
                pattern = "###.###.###-##";
                break;
            case "phone":
                pattern = customPattern;
                break;
        }
        const patternCount = pattern.length;
        for (var i = 0; i < patternCount; i++) {
            if (value[stringIndex]) {
                if (pattern[i] == "#") {
                    newString = `${newString}${value[stringIndex]}`;
                    stringIndex++;
                } else {
                    newString = `${newString}${pattern[i]}`;
                }
            }
        }
    } catch (e) {
        return value;
    } finally {
        return newString;
    }
};

export function toggleModal(id: string) {
    const button = document.getElementById(`${id}_modal_button`)
    if (button) {
        button?.click()
    }
}

export function getContentDate(date: string) {
    let yesterday = moment().subtract(1, "day").format("DD/MM/YYYY");
    let today = moment().format("DD/MM/YYYY");
    let postDate = moment(date).format("DD/MM/YYYY");

    if (today == postDate) {
        postDate = "hoje";
    }

    if (yesterday == postDate) {
        postDate = "ontem";
    }

    return postDate;
};


const conformToPattern = function (string: string, pattern: string) {
    if (!string || !pattern) return ""
    let newString = ''
    let stringIndex = 0
    const patternCount = pattern.length
    for (let i = 0; i < patternCount; i++) {
        if (string[stringIndex]) {
            if (pattern[i] == '#') {
                newString = `${newString}${string[stringIndex]}`
                stringIndex++

            } else {
                newString = `${newString}${pattern[i]}`
            }
        }
    }
    return newString
}

export const keepOnlyNumbers = (str: string): string => {
  if (!str) return ""
  if (typeof str != "string") return ""
  return str.replace(/[^\d]/g, '')
};


export const formatCPF = (value: string): string => conformToPattern(keepOnlyNumbers(value), "###.###.###-##")
export const formatPhone = (value: string): string => conformToPattern(keepOnlyNumbers(value), "(##) #####-####")
